
import MonitioringMapView from "../views/MonitoringMapView.vue";
export default {
  path: "/monitoring-map",
  name: "MapPage",
  children: [
    
    {
      path: "",
      name: "MonitoringMap",
      component: MonitioringMapView,
      meta: {
        requiresAuth: true,
        roles: ["ADMIN", "INSTALLER"],
        serverErrorSelfManage:true
      },
      beforeEnter: (to, from, next) => {
        return next();
      },
    },
  ],
  meta: {
    requiresAuth: true,
    roles: ["ADMIN", "INSTALLER"],
  },
  beforeEnter: (to, from, next) => {
    return next();
  },
};
